<template>
  <!-- <div>
  <el-menu mode="vertical" default-active="/table" class="el-menu-vertical-demo" @select="handleselect" theme="dark" router>
  <el-menu-item-group v-for="menu in menuData" :title="menu.title">
  <el-menu-item v-for="item in menu.items" :index="item.path">&nbsp;&nbsp;&nbsp;&nbsp;{{item.name}}</el-menu-item>
  </el-menu-item-group>
  </el-menu>
  </div> -->

  <!-- <div>
    <div v-for="secMenu in menuData">
      <div class="c-light-gray p-l-10 m-t-15">{{secMenu.title}}</div>
      <div class="h-50" v-for="item in secMenu.child">
        <template v-if="item.menu == menu || isContent(item)">
          <div class="w-100p h-50 p-l-40 left-menu pointer c-blue" @click="routerChange(item)">{{item.title}}</div>
        </template>
        <template v-else>
          <div class="w-100p h-50 p-l-40 left-menu pointer c-gra" @click="routerChange(item)">
            {{item.title}}
          </div>
        </template>
      </div>
    </div>
  </div> -->
  <el-menu
      :default-active="defaultActive"
      :default-openeds="defaultOpeneds"
      class="el-menu-vertical-demo"
      @select="handleselect"
      theme="dark">
    <el-submenu :index="index + ''" v-for="(secMenu, index) in menuData">
      <template slot="title">{{ secMenu.title }}</template>
      <el-tooltip
          class="item"
          effect="dark"
          v-for="(item, cIndex) in secMenu.child"
          :content="item.title"
          placement="right"
          :enterable="false"
          :open-delay="openDelayTime">
        <el-menu-item
            class="menuItemClass"
            :index="index + '-' + cIndex">
          {{item.title }}
        </el-menu-item>
      </el-tooltip>
    </el-submenu>
  </el-menu>
</template>
<style>
  .menuItemClass {
    white-space:nowrap;
    overflow: hidden;
    text-overflow:ellipsis;
  }
  .el-menu--dark .el-submenu .el-menu {
    background-color: #0e1520 !important;
  }
  .el-submenu__title {
    color: #909194 !important;
    font-size: 14px !important;
    background-color: #0e1520 !important;
    padding-left: 30px !important;
  }
  .el-menu--dark .el-submenu .el-menu {
    background-color: #0b111a !important;
  }
  .el-menu li {
    color: #abacae !important;
  }
  .el-menu li .is-active {
    color: #20a0ff !important;
  }
  .el-menu li:hover {
    background-color: #111823 !important;
  }
</style>
<script>
  export default {
    props: ['menuData', 'menu', 'secId', 'thirdId'],
    data() {
      return {
        // contentId: ''
        defaultActive: '0-0',
        defaultOpeneds: [0],
        openDelayTime: 1000
      }
    },
    created() {
      // console.log('菜单',this.menuData)
      // this.contentId = ~~this.$route.params.contentId
      if (this.secId && this.thirdId) {
        this.setCurMenuById(true)
      } else {
        setTimeout(() => {
          this.setCurMenu(true)
        }, 0)
      }
    },
    methods: {
      // isContent(item) {
      //   return item.content_id && item.content_id == this.contentId
      // },
      setCurMenu(topChange) {
        let path = this.$route.path
        let hasFound = false
        _(this.menuData).forEach((secMenu, index) => {
          if (secMenu.child) {
            _(secMenu.child).forEach((item, cIndex) => {
              if (item.url == path || item.menu == this.$route.meta.menu) {
                this.defaultActive = index + '-' + cIndex
                if (topChange) {
                  this.defaultOpeneds = [index + '']
                }
                hasFound = true
                return false
              }
            })
          }
          if (hasFound) {
            return false
          }
        })
      },
      routerChange(item) {
        // 与当前页面路由相等则刷新页面
        let path = this.$route.path.slice(1)
        if (item.url != path) {
          router.push(item.url)
        } else {
          _g.reloadPage(this)
        }
      },
      handleselect(index, indexPath) {
        let indexArr = index.split('-')
        let secIndex = indexArr[0]
        let thirdIndex = indexArr[1]
        let item = this.menuData[secIndex].child[thirdIndex]
        this.routerChange(item)
        this.defaultActive = indexPath[1]
      },
      setCurMenuById(topChange) {  // 根据激活的菜单id获取index，设置高亮
        _(this.menuData).forEach((secMenu, index) => {
          if (secMenu.id == this.secId && secMenu.child) {
            if (topChange) {
              this.defaultOpeneds = [index + '']
            }
            _(secMenu.child).forEach((item, cIndex) => {
              if (item.id == this.thirdId) {
                this.defaultActive = index + '-' + cIndex
                return false
              }
            })
            return false
          }
        })
        this.$emit('setActiveId', '', '')
      }
    },
    watch: {
      'menuData' () {
        if (this.secId && this.thirdId) {
          this.setCurMenuById(true)
        } else {
          setTimeout(() => {
            this.setCurMenu(true)
          }, 0)
        }
      },
      '$route' (to, from) {               // 监听路由改变
        if (this.secId && this.thirdId) {
          this.setCurMenuById(false)
        } else {
          setTimeout(() => {
            this.setCurMenu(false)
          }, 0)
        }
        // this.contentId = ~~to.params.contentId
      }
    }
  }
</script>


// WEBPACK FOOTER //
// leftMenu.vue?879adace